const $ = jQuery;

/**
 * Update the cart button depending on the validation status of the bundle.
 *
 * @param {Object|undefined|null} updateData - The data object for the bundle.
 *
 * @returns {void}
 */
const handleUpdateCart = (updateData) => {
  if (!updateData) return;
  const $cartButton = $(`.add-to-cart-floater`);
  if (!$cartButton) return;
  if (!updateData.passes_validation()) {
    $cartButton.prop("disabled", true);
    return;
  }
  $cartButton.prop("disabled", false);
};

/**
 * Handles adding event listeners to the bundle data object.
 *
 * @param {Object|undefined|null} bundleData - The data object for the bundle.
 *
 * @returns {void}
 */
const handleBundleCart = (bundleData) => {
  if (!bundleData) {
    return;
  }
  handleUpdateCart(bundleData);
  bundleData.$bundle_data.on(
    "woocommerce-product-bundle-validation-status-changed",
    function () {
      let updateData = getData($(this));
      if (!updateData) {
        return;
      }
      handleUpdateCart(updateData);
    },
  );
};

/**
 * Get the data object for the bundle.
 * @param {jQuery} el The element to get the data from.
 * @returns {Object|boolean}
 */
const getData = (el) => {
  const bundleId = el.data("bundle_id");
  if (!bundleId) {
    return false;
  }
  if (!wc_pb_bundle_scripts || !wc_pb_bundle_scripts[bundleId]) {
    return false;
  }
  return wc_pb_bundle_scripts[bundleId];
};

/**
 * Handles the animations for the cart button.
 *
 * @param {jQuery} $scrollToCartBtn - The cart button to animate.
 *
 * @returns {void}
 */
const handleAnimations = ($scrollToCartBtn) => {
  if (
    $(document).scrollTop() < $(".product-tease-description").position().top
  ) {
    $scrollToCartBtn.hide();
  } else {
    $scrollToCartBtn.show();
  }
  $(document).on("scroll", function () {
    if ($(this).scrollTop() < $(".product-tease-description").position().top) {
      $scrollToCartBtn.hide();
      return;
    }
    $scrollToCartBtn.show();
  });
};

/**
 * Adds the cart button to the bundle.
 *
 * @param {number} bundle_id - The ID of the bundle.
 *
 * @returns {void}
 */
const addCartButton = (bundle_id) => {
  if ($(".add-to-cart-floater").length > 0) {
    return;
  }
  if (!window.puhti_bundle) {
    return;
  }
  const $scrollToCartBtn = $(
    `<button class="add-to-cart-floater" disabled data-bundle_id="${bundle_id}">${window.puhti_bundle.add_to_cart_text}</button>`,
  ).appendTo($(`.bundle_form`));
  if ($scrollToCartBtn && $(".product-tease-description").length > 0) {
    // Show animations if we have the product-tease-description.
    handleAnimations($scrollToCartBtn);
  }
  $scrollToCartBtn.on("click", function (ev) {
    // We need to do this, as the button is inside a form, and we don't want to submit the form.
    ev.preventDefault();
    ev.stopPropagation();
    const $current = $(this);
    const bundle_id = $current.data("bundle_id");
    const $cart = $(`.cart.bundle_data[data-bundle_id='${bundle_id}']`);
    if (
      $cart.length > 0 &&
      $cart.find("button[name='add-to-cart']").length > 0
    ) {
      $cart.find("button[name='add-to-cart']").trigger("click");
    }
  });
};

$(document).ready(function () {
  const $bundleFormData = $(".bundle_form .bundle_data");
  if ($bundleFormData.length === 0) {
    return;
  }
  $bundleFormData.each(function () {
    const $bundle_data = $(this);
    $bundle_data.on("woocommerce-product-bundle-initialized", function () {
      const $data = $(this);
      const bundleData = getData($data);
      if (!bundleData) {
        return;
      }
      addCartButton(bundleData.bundle_id);
      handleBundleCart(bundleData);
    });
  });
});
